export type WhitelabelConfig = {
  name: string;
  primaryColor: string;
  logoUrl: string;
};

// Default config; can be swapped per deployment/tenant
export const whitelabel: WhitelabelConfig = {
  name: 'Baita Super',
  primaryColor: '#C5201A',
  logoUrl: '/logo/logo_full_white.png',
};
